import { GetterTree } from 'vuex'
import { UserState, RootState } from '../storeTypes'
const getters: GetterTree<UserState, RootState> = {
}

export default getters
